import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { EmployeeConsumptionReport, EmployeeConsumptionRequest } from '../interfaces/report.interface';

export const ReportService = {
    getEmployeeConsumption: async (request: EmployeeConsumptionRequest): Promise<EmployeeConsumptionReport[]> => {
        const response = await axios.post(ENDPOINTS.REPORT.EMPLOYEE_CONSUMPTION, request);
        return response.data;
    }
};
